// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5754":"2ba6992f","8036":"58551e2e"}[chunkId] + ".chunk.css";
};